module.exports = __webpack_public_path__ + "static/media/fill_extrusion_pattern.vertex.ff6868a2.glsl";